<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  import ApplicationFooter from "./components/footer/footer.vue";
  import ApplicationBrandBar from "./components/header/brandBar/brandBar.vue";
  import storage from '@/helpers/storage'
  import affix from 'vuelation-affix'
  import 'bootstrap'
  import 'tether'
  import 'jquery.cookie'
  import 'sticky-table-headers'
  import 'toastr'
  import 'file-saverjs'
  let environment = process.env.NODE_ENV;
  let brandDetails = "";
  if (environment === 'production') {
    brandDetails = require('./brand-details.json');
  } else if (environment === 'stage') {
    brandDetails = require('./brand-details-stage.json');
  } else {
    brandDetails = require('./brand-details-dev.json');
  }
  export default {
    name: 'app',
    components: {
      ApplicationFooter,
      ApplicationBrandBar,
      affix
    },
    created() {
      this.isAuthenticated();
      this.$auth.authStateManager.subscribe(this.isAuthenticated)
      this.loadBrandCss()
    },
    mounted() {
      /* uncomment for branding to work in IE 11 */
      cssVars(); // eslint-disable-line
    },
    data() {
      return {
        authenticated: false
      }
    },
    watch: {
      '$route': 'isAuthenticated'
    },
    methods: {
      async isAuthenticated () {
        this.authenticated = await this.$auth.isAuthenticated()
      },
      async logout () {
        await this.$auth.logout();
        await this.isAuthenticated();
      },
      loadBrandCss() {
        console.log('applying brand specific css...')
        var lnk = document.createElement('link');
        lnk.type = 'text/css';
        lnk.rel = 'stylesheet';
        var brand = brandDetails.data.filter(i => i.applicationUrls.indexOf(document.location.host) > -1)
        var cssToApply = brand.length ? brand[0].cssFileName : 'cargill.css'
        console.log('applying css... : ' + cssToApply)
        storage.set('brand', brand.length ? brand[0].brandName : '')
        lnk.href = '../static/' + cssToApply
        document.getElementsByTagName('head')[0].appendChild(lnk);
        document.getElementsByTagName('title')[0].text = 'my' + brand[0].brandName + ' Identity'
      }
    }
  }
</script>
<style lang="scss">
  @import "../src/scss/main.scss";
  @import "../src/assets/css/cfApp.css";
</style>



// WEBPACK FOOTER //
// App.vue?c893b020